<div class="page-layout blank p-24" fusePerfectScrollbar fxLayout="column">
  <div fxLayout="column">
    <app-breadcrumb [title]="dataBreadcumbTitle" [description]="dataBreadcumbPages"></app-breadcrumb>
    <div fxLayout="row"  fxLayout.sm="column" fxLayout.xs="column" class="cards-container">
      <mat-card class="card-nueva-prestacion">
        <div class="sub-title title-nueva-prestacion">
          <span>Documentación básica</span><svg (click)="openModal()" class="docBasicaInfo"
            xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path
              d="M14.25 19.5C14.25 19.7472 14.1767 19.9889 14.0393 20.1945C13.902 20.4 13.7068 20.5602 13.4784 20.6549C13.25 20.7495 12.9986 20.7742 12.7561 20.726C12.5137 20.6777 12.2909 20.5587 12.1161 20.3839C11.9413 20.2091 11.8223 19.9863 11.774 19.7439C11.7258 19.5014 11.7505 19.2501 11.8452 19.0216C11.9398 18.7932 12.1 18.598 12.3055 18.4607C12.5111 18.3233 12.7528 18.25 13 18.25C13.3315 18.25 13.6495 18.3817 13.8839 18.6161C14.1183 18.8505 14.25 19.1685 14.25 19.5ZM13 6.25C10.375 6.25 8.25001 8.15625 8.25001 10.5V11C8.25001 11.1989 8.32902 11.3897 8.46968 11.5303C8.61033 11.671 8.80109 11.75 9.00001 11.75C9.19892 11.75 9.38968 11.671 9.53034 11.5303C9.67099 11.3897 9.75001 11.1989 9.75001 11V10.5C9.75001 8.98375 11.2075 7.75 13 7.75C14.7925 7.75 16.25 8.98375 16.25 10.5C16.25 12.0162 14.7925 13.25 13 13.25C12.8011 13.25 12.6103 13.329 12.4697 13.4697C12.329 13.6103 12.25 13.8011 12.25 14V15C12.25 15.1989 12.329 15.3897 12.4697 15.5303C12.6103 15.671 12.8011 15.75 13 15.75C13.1989 15.75 13.3897 15.671 13.5303 15.5303C13.671 15.3897 13.75 15.1989 13.75 15V14.6975C16.0138 14.375 17.75 12.615 17.75 10.5C17.75 8.15625 15.625 6.25 13 6.25ZM25.75 13C25.75 15.5217 25.0022 17.9868 23.6012 20.0835C22.2003 22.1802 20.209 23.8144 17.8792 24.7795C15.5495 25.7445 12.9859 25.997 10.5126 25.505C8.03935 25.0131 5.76751 23.7987 3.98439 22.0156C2.20127 20.2325 0.986955 17.9607 0.494993 15.4874C0.00303192 13.0141 0.255524 10.4505 1.22054 8.12079C2.18556 5.79103 3.81976 3.79975 5.91648 2.39876C8.01321 0.997774 10.4783 0.25 13 0.25C16.3803 0.25397 19.621 1.59854 22.0112 3.98877C24.4015 6.379 25.746 9.61971 25.75 13ZM24.25 13C24.25 10.775 23.5902 8.59989 22.354 6.74984C21.1179 4.89978 19.3609 3.45784 17.3052 2.60636C15.2495 1.75487 12.9875 1.53208 10.8052 1.96617C8.62295 2.40025 6.6184 3.47171 5.04505 5.04505C3.47171 6.61839 2.40025 8.62295 1.96617 10.8052C1.53209 12.9875 1.75488 15.2495 2.60636 17.3052C3.45785 19.3609 4.89979 21.1179 6.74984 22.354C8.59989 23.5902 10.775 24.25 13 24.25C15.9827 24.2467 18.8422 23.0604 20.9513 20.9513C23.0604 18.8422 24.2467 15.9827 24.25 13Z"
              fill="#D65D27" />
          </svg>
        </div>
        <div class="datos-basicos">
          <p>Es obligatorio adjuntarla para solicitar una prestación.</p>
        </div>
        <div class="botones-acciones">
          <span><strong>Tenés {{ numberDocsUp }} de {{ totalDocuments }} documentos cargados</strong></span>
          <!-- <button class="confirmar-presetacion">Adjuntar Archivos</button> -->
          <button-primary-orange-component label="Adjuntar Archivos" [disabled]="isLoading"
            (onClick)="openModalBasicDoc()">
          </button-primary-orange-component>
        </div>
      </mat-card>

      <mat-card class="card-nueva-prestacion">
        <div class="sub-title title-nueva-prestacion">
          <span>Datos de contacto</span>
        </div>
        <div class="datos-basicos">
          <p>Recordá tenerlos actualizados.</p>
        </div>
        <div class="botones-acciones">
          <span>Te contactaremos a <strong class="email-card-datos-contacto" title = "{{userData.email}}">{{ userData.email }}</strong></span>
          <button-primary-orange-component label="Modificar Datos" [disabled]="isLoading" class="modificar-datos"
            (onClick)="openModalUserInformation()">
          </button-primary-orange-component>
        </div>
      </mat-card>
    </div>
  </div>
  <app-alerta-observacion-documentacion [documentacionBasica]="documentationBasica"></app-alerta-observacion-documentacion>
  <ng-container *ngIf="isLoadingPrestaciones || isLoadingDatosNomenclador">
    <div id="spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoadingPrestaciones && !isLoadingDatosNomenclador && numeroDePrestaciones != 0">
    <div class="contenedor-titulo-nuevas-prestaciones">
      <span><img class="logo-titulo-nuevas-prestaciones" src="./assets/icons/DA-icons/danger.svg"></span>
      <span class="titulo-nuevas-prestaciones">Prestaciones que requieren tu atención</span>
    </div>
    <div id="spinner" *ngIf="loadingPrestaciones">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
    <div *ngIf="!loadingPrestaciones">
      <ng-container *ngFor="let dataPrestacion of prestacionesQueRequierenAtencion; let i = index">
        <!--Form de prestaciones que requieren atencion-->
          <div class="contenedor-componente-form-prestacion">
              <app-form-prestacion 
                *ngIf="dataPrestacion.estado !== 'Observed' && (dataPrestacion.secuencia === '' || dataPrestacion.secuencia === null)" 
                cardTitle="Prestación sin enviar" 
                prestacionType="{{dataPrestacion?.nomencladordescripcion}}" 
                [sessionId]="modalData.user_data.sessionId" 
                [nroOrden]="orden" 
                [nroBeneficiario]="nroBenef" 
                [cardPrestacionPosicion]="i" 
                [dataPrestacionRequiereAtencion]=dataPrestacion 
                [cardAdvice]="getCardAdvice(dataPrestacion.estado)" 
                [datosNomenclador]="datosNomenclador" 
                [ngClass]="{'sombra-destacada': i === idPrestacionCreada && destacarPrestacionCreada && envioPrestacion}" 
                (click)="onPrestacionClick()" 
                (loadPrestaciones) = "loadPrestaciones($event)" >
              </app-form-prestacion>
              <app-prestacion-observada 
                *ngIf="dataPrestacion.estado === 'Observed' || (dataPrestacion.secuencia != '' && dataPrestacion.secuencia != null)" 
                [cardTitle]="dataPrestacion.estadosgi === 'PRE APROBADA' ? 'Prestación preaprobada' : 'Prestación observada'" 
                prestacionType="{{dataPrestacion?.nomencladordescripcion}}" 
                [dataPrestacionRequiereAtencion]=dataPrestacion 
                [cardAdvice]="getCardAdvice(dataPrestacion.estado,dataPrestacion.observaciones)" 
                [ngClass]="{'sombra-destacada': i === idPrestacionCreada && destacarPrestacionCreada && envioPrestacion}" 
                (click)="onPrestacionClick()" 
                (loadPrestaciones) = "loadPrestaciones($event)" >
              </app-prestacion-observada>
          </div>
      </ng-container>
    </div>

  </ng-container>


  <div *ngIf="isLoadingDatosNomenclador == false" >
    <div class="contenedor-titulo-nuevas-prestaciones" id="form-nueva-prestacion-unico">
      <span><img class="logo-titulo-nuevas-prestaciones" src="./assets/icons/DA-icons/done-bw.svg"></span>
      <span class="titulo-nuevas-prestaciones">Nuevas Prestaciones</span>
    </div>
    <!--Form de prestación-->


    <div class="contenedor-componente-form-prestacion" #formNuevaPrestacion>
      <app-form-prestacion 
        cardTitle="Nueva Prestación" 
        isNewPrestacion="true" 
        [scrollSection]="nueva-prestacion-form" 
        (isLoadingPrestaciones)="onLoadingChanged($event)" 
        (prestacionesQueRequierenAtencion)="recibirPrestacionesDesdeFormNuevaPrestacion($event)" 
        [numeroPrestacion]="numeroDePrestaciones" 
        [sessionId]="modalData.user_data.sessionId" 
        [nroOrden]="orden" 
        [nroBeneficiario]="nroBenef" 
        [datosNomenclador]="datosNomenclador" 
        (loadPrestaciones) = "loadPrestaciones($event)" >
        
      </app-form-prestacion>
    </div>
  
    <!--Prestaciones a enviar-->
    <div class="contenedor-componente-prestaciones-a-enviar">
        <app-prestaciones-aenviar 
          [userData]="modalData.user_data"  
          [cuilPrestacion] = "cuil" 
          [prestacionesAEnviar]="prestacionesCompletadas?.length" 
          [docBasicaRequerida]="numberDocsRequired" 
          [cantidadDocBasica]="numberDocsRequiredUp"
          [nroOrden]="orden"
          [nroBeneficiario]="nroBenef"
          ></app-prestaciones-aenviar>
    </div>
  </div>
</div>

<!-- </div>
<div class="botones-acciones">
  <button-secundary-blue-light-component
    label="Modificar"
    [disabled]="false"
    (onClick)="openModal()"
  ></button-secundary-blue-light-component>
  <button-primary-orange-component
    label="Confirmar"
    [disabled]="false"
    >
  </button-primary-orange-component>
</div>
</div>
</div> -->